import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenOrderDeliveryTracking from '../../../../../containers/app/common/OpenOrderDeliveryTracking';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Select from '../../../../../components/input/Select';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import {
  ORDER_ACCEPT_MANAGER_TEXT,
  ORDER_DELIVERY_TYPE,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_EXCHANGE_STATUS,
  ORDER_EXCHANGE_STATUS_TEXT,
  ORDER_EXCHANGE_TYPE_TEXT,
  ORDER_GIFT_STATUS_SELECT_LIST,
  ORDER_GIFT_STATUS_TEXT,
  ORDER_TYPE_SELECT_LIST,
  ORDER_TYPE_TEXT,
  PAYMENT_METHOD_TYPE_SELECT_LIST,
  PAY_METHOD_TYPE_TEXT,
  RETURN_EXCHANGE_REASON_TYPE,
} from '../../../../../constants/service/app/orderConstants';
import {
  addAllItemToSelectList,
  setClearDash,
  setColumnWidth,
  setDash,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import { setOrderMessage } from '../../../../../lib/utils/orderutils';
import OpenReturnExchangeAttachment from '../../../../../containers/app/common/OpenReturnExchangeAttachment';

/**
 *  주문 교환 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter, mainProductCategorySelectList } = data;
  return [
    {
      accessor: 'orderType',
      Header: '주문 타입',
      filterable: true,
      width: setColumnWidth(list, 'orderType'),
      Cell: (row) => setDash(ORDER_TYPE_TEXT[row.value]),
      Filter: () => (
        <Select
          isTable
          list={addAllItemToSelectList(ORDER_TYPE_SELECT_LIST)}
          value={filterOption.orderType}
          onChange={(orderType) => onFilter({ orderType })}
        />
      ),
    },
    {
      accessor: 'giftStatus',
      Header: '선물 상태',
      filterable: true,
      width: 150,
      Cell: (row) => setDash(ORDER_GIFT_STATUS_TEXT[row.value]),
      Filter: () => (
        <Select
          isTable
          list={addAllItemToSelectList(ORDER_GIFT_STATUS_SELECT_LIST)}
          value={filterOption.giftStatus}
          onChange={(giftStatus) => onFilter({ giftStatus })}
        />
      ),
    },
    {
      Header: '교환 정보',
      fixed: 'left',
      columns: [
        {
          accessor: 'orderId',
          Header: '주문번호',
          filterable: true,
          width: 150,
          Filter: () => (
            <TableFilterInput option={filterOption.orderId} onFilter={(orderId) => onFilter({ orderId })} />
          ),
        },
        {
          accessor: 'orderItemId',
          Header: '상품 주문번호',
          filterable: true,
          width: 150,
          Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.orderItemId} onFilter={(orderItemId) => onFilter({ orderItemId })} />
          ),
        },
        {
          accessor: 'orderExchangeStatus',
          Header: '교환 처리 상태',
          Cell: (row) => ORDER_EXCHANGE_STATUS_TEXT[row.value] || '_',
        },
        {
          accessor: 'exchangeType',
          Header: '교환 사유',
          width: 120,
          Cell: (row) => (
            <OpenReturnExchangeAttachment
              title="교환사유"
              orderReturnExchangeId={row.original.orderExchangeId}
              type={RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REQUEST}
              text={ORDER_EXCHANGE_TYPE_TEXT[row.value]}
              reason={row.original.changeReason}
            />
          ),
        },
        {
          accessor: 'acceptManager',
          Header: '교환 접수자',
          width: 100,
          Cell: (row) => setDash(ORDER_ACCEPT_MANAGER_TEXT[row.value]),
        },
      ],
    },
    {
      Header: '교환 거부',
      columns: [
        {
          accessor: 'rejectReason',
          Header: '거부 사유',
          width: 110,
          Cell: (row) => (
            <OpenReturnExchangeAttachment
              title="교환 거부사유"
              orderReturnExchangeId={row.original.orderExchangeId}
              type={RETURN_EXCHANGE_REASON_TYPE.EXCHANGE_REJECT}
              text="사유 보기"
              reason={row.value}
            />
          ),
        },
        {
          accessor: 'rejectDate',
          Header: '거부 일시',
          width: 130,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
        },
      ],
    },
    {
      Header: '교환 배송 상태',
      columns: [
        {
          accessor: 'deliveryType',
          Header: '교환 배송 방법',
          width: 120,
          Cell: (row) => ORDER_DELIVERY_TYPE_TEXT[row.value] || '_',
        },
        {
          accessor: 'deliveryEnterprise',
          Header: '교환 배송 택배사',
          width: 130,
          Cell: (row) => setDash(row.value),
        },
        {
          accessor: 'invoiceNumber',
          Header: '교환 배송 송장 번호',
          filterable: true,
          width: 140,
          Cell: (row) => setDash(row.value),
          Filter: () => (
            <TableFilterInput
              option={filterOption.invoiceNumber}
              onFilter={(invoiceNumber) => onFilter({ invoiceNumber })}
            />
          ),
        },
        {
          Header: '배송 추적',
          Cell: (row) => {
            /**
             *  상품 주문 교환 상태가 교환 품 배송 중/ 교환품 배송 완료이며,
             *  택배방법이 [택배, 등기, 소포]일 경우에만 추적 활성화
             */
            if (
              (row.original.orderExchangeStatus === ORDER_EXCHANGE_STATUS.DELIVERY_SHIPPING ||
                row.original.orderExchangeStatus === ORDER_EXCHANGE_STATUS.DONE) &&
              row.original.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY
            )
              return <OpenOrderDeliveryTracking deliveryId={row.original.deliveryId} />;
            else return setDash(row.value);
          },
        },
        {
          accessor: 'paymentDate',
          Header: '결제 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.paymentDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ paymentDate: data })}
            />
          ),
        },
        {
          accessor: 'exchangeRequestDate',
          Header: '교환 요청 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.exchangeRequestDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ exchangeRequestDate: data })}
            />
          ),
        },
        {
          accessor: 'exchangeReceiveDate',
          Header: '교환품 수거 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.exchangeReceiveDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ exchangeReceiveDate: data })}
            />
          ),
        },
        {
          accessor: 'exchangeDelayDate',
          Header: '교환품 처리 지연 일시',
          width: 160,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
        },
        {
          accessor: 'deliveryDispatchDate',
          Header: '교환품 발송 처리 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.deliveryDispatchDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ deliveryDispatchDate: data })}
            />
          ),
        },
        {
          accessor: 'deliveryCompleteDate',
          Header: '교환품 배송 완료 일시',
          sortable: true,
          filterable: true,
          width: 320,
          Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
          Filter: () => (
            <DateRangePicker
              value={filterOption.deliveryCompleteDate}
              outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
              onSelect={(data) => onFilter({ deliveryCompleteDate: data })}
            />
          ),
        },
      ],
    },
    {
      exchangeDeliveryDispatchDate: null,
      Header: '구매 상품 정보',
      columns: [
        {
          accessor: 'brandName',
          Header: '브랜드명',
          resizable: true,
          filterable: true,
          width: setColumnWidth(list, 'brandName'),
          Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
          Filter: () => (
            <TableFilterInput option={filterOption.brandName} onFilter={(brandName) => onFilter({ brandName })} />
          ),
        },
        {
          accessor: 'storeId',
          Header: '브랜드 ID',
          filterable: true,
          width: 70,
          Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />
          ),
        },
        {
          accessor: 'productId',
          Header: '상품번호',
          filterable: true,
          Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
          Filter: () => (
            <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
          ),
        },
        {
          accessor: 'productName',
          Header: '상품명',
          className: 'align-left',
          resizable: true,
          filterable: true,
          width: setColumnWidth(list, 'productName'),
          Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
          Filter: () => (
            <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
          ),
        },
        {
          accessor: 'mainCategory',
          Header: '1차 카테고리',
          width: setColumnWidth(list, 'mainCategory') + 40,
          filterable: true,
          Filter: () => (
            <Select
              list={addAllItemToSelectList(mainProductCategorySelectList)}
              onChange={(mainCategory) =>
                onFilter({
                  mainCategory,
                  subCategory: null,
                })
              }
              defaultValue={filterOption.mainCategory}
              value={filterOption.mainCategory}
              isTable={true}
              size="large"
            />
          ),
        },
        {
          accessor: 'productOptionName',
          Header: '옵션정보',
          resizable: true,
          width: setColumnWidth(list, 'productOptionName'),
          Cell: (row) => setDash(row.value),
        },
        {
          accessor: 'quantity',
          Header: '수량',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productOriginalPrice',
          Header: '상품 가격(정가)',
          width: 130,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productDiscountPrice',
          Header: '상품 할인액(차감된 금액)',
          width: 160,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'productOptionPrice',
          Header: '옵션 가격',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'usedCoupon',
          Header: '쿠폰',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'usedPoint',
          Header: '포인트',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'totalPrice',
          Header: '상품별 총 주문금액',
          width: 150,
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'deliveryExtraFee',
          Header: '추가 배송비',
          Cell: (row) => setNumberWithComma(row.value),
        },
        {
          accessor: 'orderMessage',
          Header: '주문 메시지',
          Cell: (row) => setOrderMessage(row.value),
        },
      ],
    },
    {
      Header: '구매자 정보',
      columns: [
        {
          accessor: 'buyerAccount',
          Header: '구매자 ID',
          filterable: true,
          width: setColumnWidth(list, 'buyerAccount'),
          Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
          Filter: () => (
            <TableFilterInput
              option={filterOption.buyerAccount}
              onFilter={(buyerAccount) => onFilter({ buyerAccount })}
            />
          ),
        },
        {
          accessor: 'buyerName',
          Header: ' 구매자명',
          filterable: true,
          width: setColumnWidth(list, 'buyerName'),
          Filter: () => (
            <TableFilterInput option={filterOption.buyerName} onFilter={(buyerName) => onFilter({ buyerName })} />
          ),
        },
        {
          accessor: 'exchangeBuyerPhone',
          Header: '구매자 연락처',
          filterable: true,
          width: 170,
          Cell: (row) => (
            <SendMessageService
              text={setPhoneFormat(row.value)}
              memberType={AMONDZ_MEMBER_TYPE.USER}
              targetId={row.original.userId}
            />
          ),
          Filter: () => (
            <TableFilterInput
              option={filterOption.exchangeBuyerPhone}
              onFilter={(exchangeBuyerPhone) =>
                onFilter({
                  exchangeBuyerPhone: setClearDash(exchangeBuyerPhone),
                })
              }
            />
          ),
        },
        {
          accessor: 'recipientName',
          Header: '수취인명',
          filterable: true,
          width: setColumnWidth(list, 'recipientName'),
          Filter: () => (
            <TableFilterInput
              option={filterOption.recipientName}
              onFilter={(recipientName) => onFilter({ recipientName })}
            />
          ),
        },
        {
          accessor: 'exchangeRecipientPhone',
          Header: '수취인 연락처',
          filterable: true,
          width: 170,
          Cell: (row) => (
            <SendMessageService
              text={setPhoneFormat(row.value)}
              memberType={AMONDZ_MEMBER_TYPE.RECIPIENT}
              targetId={row.original.orderItemId}
            />
          ),
          Filter: () => (
            <TableFilterInput
              option={filterOption.exchangeRecipientPhone}
              onFilter={(exchangeRecipientPhone) =>
                onFilter({
                  exchangeRecipientPhone: setClearDash(exchangeRecipientPhone),
                })
              }
            />
          ),
        },
        {
          accessor: 'address',
          Header: '배송지',
          resizable: true,
          width: setColumnWidth(list, 'address'),
        },
        {
          accessor: 'postCode',
          Header: '우편번호',
        },
        {
          accessor: 'message',
          Header: '배송 메시지',
          className: 'align-left',
          resizable: true,
          width: 200,
        },
      ],
    },
    {
      Header: '결제',
      columns: [
        {
          accessor: 'payMethod',
          Header: '결제수단',
          filterable: true,
          width: 170,
          Cell: (row) => PAY_METHOD_TYPE_TEXT[row.value] || '_',
          Filter: () => (
            <Select
              list={PAYMENT_METHOD_TYPE_SELECT_LIST}
              onChange={(payMethod) => onFilter({ payMethod })}
              defaultValue={filterOption.payMethod}
              value={filterOption.payMethod}
              isTable={true}
              size="large"
            />
          ),
        },
      ],
    },
  ];
};

export default columns;
